<template>
    <div class="flex border-t border-l border-r border-gray-200 bg-white">
        <estimate-cost-list-update-labour-dropdown #default="{ open:openConfirm, close:close }"
                                                   class="flex-1"
                                                   :item="labour"
                                                   :original="item"
                                                   :type="type"
                                                   :align-right="true"
                                                   @updated="update"
                                                   @closed="closedUpdate"
                                                   menu-class="w-96"
                                                   trigger-class="flex w-full">
            <div class="flex-1 flex">
                <estimate-task-item-labour-search
                    class="flex w-full w-128"
                    menu-class="w-[34em]"
                    #default="{ open, query, setQuery }"
                    :store="store"
                    :estimate="estimate"
                    @selected:labourRate="(e) => labourSelected(e,openConfirm)"
                    @change="openConfirm()"
                    :top="true"
                >
                    <!-- Name. -->
                    <autoresizable-textarea :height="el => (el.scrollHeight + 2) + 'px'"
                                            ref="autoresizable-textarea" v-if="!estimate.readonly">
                <textarea
                    placeholder="Name..."
                    class="text-sm -ml-px mr-px -my-px px-2 py-1.5 border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                    type="text"
                    ref="name"
                    v-model="labour.name"
                    rows="1"
                    @focus="setQuery($event.target.value);open()"
                    @input="setQuery($event.target.value);openConfirm()"
                ></textarea>
                    </autoresizable-textarea>
                    <div v-else
                         class="text-sm -ml-px mr-px -my-px px-2 py-1.5 whitespace-pre-wrap border border-gray-200 shadow-none relative hover:z-10 focus:z-20 resize-none bg-white"
                         v-text="labour.name"
                    ></div>
                </estimate-task-item-labour-search>
            </div>
            <div class="w-28 m-0 -mx-px flex">
                <page-cell
                    currency
                    class="text-sm -ml-px -my-px px-2 py-1.5 border-gray-200"
                    placeholder="Cost..."
                    :read-only="estimate.readonly"
                    @input="openConfirm()"
                    v-model="labour.rate"
                    ref="cost"
                ></page-cell>
            </div>
            <div class="w-20 m-0 -mx-px flex">
                <div class="w-full bg-gray-50 -my-px -ml-px border px-2 py-1.5 text-sm text-right">
                    {{ item.quantity | rounded }}
                </div>
            </div>
            <div class="w-28 m-0 -mx-px flex">
                <div class="w-full bg-gray-50 -my-px mr-0 border px-2 py-1.5 text-sm text-right">
                    {{ item.rate * item.quantity | toCurrency }}
                </div>
            </div>
        </estimate-cost-list-update-labour-dropdown>
    </div>
</template>

<script>

import AutoresizableTextarea from "../../../ui/AutoresizableTextarea";
import EstimateTaskItemMaterialSearch from "../build/EstimateTaskItemMaterialSearch.vue";
import EstimateCostListCostUpdateMaterialDropdown from "./EstimateCostListUpdateMaterialDropdown.vue";
import {resolveNumericText} from "../../../../utils";

export default {
    components: {EstimateCostListCostUpdateMaterialDropdown, EstimateTaskItemMaterialSearch, AutoresizableTextarea},
    props: {
        estimate: Object,
        target: Object,
        item: Object,
        store: Object,
        type: String,
    },
    data() {
        return {
            labour: {name: this.item.name, rate: this.item.rate},
            resolveNumericText,
        }
    },
    computed: {},
    methods: {
        labourSelected({labourRateName, labourRateCost}, openConfirm) {
            this.labour.name = labourRateName
            this.labour.rate = this.resolveNumericText(labourRateCost)
            openConfirm()
        },
        update(e) {
            this.labour.rate = this.resolveNumericText(this.labour.rate)
            this.$emit('updateLabour', {from: this.item, to: this.labour})
        },
        closedUpdate(e) {
            this.$nextTick(() => {
                this.labour = {name: this.item.name, rate: this.item.rate}
            })
        }
    },
}
</script>
